import Reveal from '../components/Reveal';
import StoreButton from '../components/StoreButton';

export default function DownloadCTA() {
  return (
    <div className="download-bg" id="download">
      <div
        className="download-glow"
        aria-hidden="true"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/assets/spin/glow-burst.svg)`,
          backgroundSize: '60%',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      />
      <div className="download-inner">
        <Reveal>
          <div className="download-mascot">
            <img src="/assets/mascot/mascot-cheer.svg" alt="Cheering mascot" />
          </div>
          <p className="section-label" style={{ textAlign: 'center' }}>Free to Play</p>
          <h2 className="section-title" style={{ textAlign: 'center' }}>Start Your Word Journey Today</h2>
          <p style={{ fontSize: 17, color: 'rgba(255,255,255,0.8)', lineHeight: 1.65, textAlign: 'center', maxWidth: 480, margin: '0 auto' }}>
            Download Lexira free on iOS and Android. No ads to start, offline-ready, and new content every day.
          </p>
          <div className="download-btns">
            <StoreButton store="apple" large />
            <StoreButton store="google" large />
          </div>
        </Reveal>
      </div>
    </div>
  );
}
